import axios from 'axios';

const MEMBER_API_BASE = '/api/auth'

export default {
  async getProfile () {
    const res = await axios.get(`${MEMBER_API_BASE}/profile`);
    return res.data;
  },
  async updateProfile (user) {
    const res = await axios.put(`${MEMBER_API_BASE}/profile`, user);
    return res.data;
  },
  async changePassword (data) {
    const res = await axios.put(`${MEMBER_API_BASE}/password`, data);
    return res.data;
  },
  async checkPassword (userId, password) {
    const res = await axios.post(`${MEMBER_API_BASE}/checkpassword`, { userId, password });
    return res.data
  }
}
